module.exports = undefined


//////////////////
// WEBPACK FOOTER
// ./src/data/about/facilities.yml
// module id = B1Wg
// module chunks = 1